@defer(when deliveryOptionSelected()) {
@if (deliveryOption.length > 1) {
<!-- Delivery type selection -->
<p class="signup__sub-head-text">What kind of delivery are you interested in?</p>

<mat-radio-group id="mat-radio-group" class="row" [(ngModel)]="deliveryOptionSelected"
  (ngModelChange)="getPickupOptions($event)" (click)="updateDeliverySelection(true)">

  @for (delivery of deliveryOption; track $index) {
  <div class="col-sm-4">
    <mat-radio-button [checked]="delivery.id === deliveryOptionSelected()?.id" [value]="delivery">
      {{delivery.name}}
    </mat-radio-button>
  </div>
  }

</mat-radio-group>
}

<!-- Delivery type which requires pickup options configuration: -->
@if(!deliveryOptionSelected()?.configuration?.requireAddress){

<!-- Email + Pickup address on one row -->
<div class="row form-row mt-5 animated fadeInDown">
  <div class="col-md-6">
    <div class="form-floating">
      <input type="email" class="form-control" name="signupEmailPickup" placeholder="Email"
        [class.is-invalid]="(signupEmail() !== '' && !isSignupEmailValid()) || emailAlreadyInUse()"
        [class.is-valid]="isSignupEmailValid() && isEmailAvailable()"
        [disabled]="isCheckingEmail()"
        [ngModel]="signupEmail()"
        (ngModelChange)="onEmailChange($event)"
        (blur)="onEmailBlur()" />
      <label for="signupEmailPickup">Email</label>
      @if (signupEmail() !== '' && !isSignupEmailValid()) {
      <div class="invalid-feedback d-block">
        <i class="fas fa-xmark"></i>
        Please enter a valid email address
      </div>
      } @else if (emailAlreadyInUse()) {
      <div class="invalid-feedback d-block">
        <i class="fas fa-xmark"></i>
        This email is already in use. Please use another or sign in.
      </div>
      } @else if (isCheckingEmail()) {
      <div class="form-text small text-muted d-block">
        <i class="fas fa-spinner fa-spin"></i>
        Checking email...
      </div>
      }
    </div>
  </div>
  <!-- PickUp options: dropdown if there is more than one option, otherwise a readonly input -->
  <div class="col-md-6">
    @if (pickUpOptions.length > 1) {
    <mat-form-field class="w-100" [class.option-selected]="!!selectedPickUpOption()">
      <mat-label>Pickup Address</mat-label>
      <mat-select name="selectedPickUpOption" [value]="selectedPickUpOption()?.id || null"
        (selectionChange)="setSelectedPickUpOption($event)">
        @for (item of pickUpOptions; track $index) {
        <mat-option [value]="item.id">{{ item.composedName }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
    } @else {
    <div class="form-floating">
      <input type="text" class="form-control" id="pickupLocation" name="pickUpLocation" readonly
        [value]="selectedPickUpOption()?.composedName || ''" placeholder>
      <label for="pickupLocation">Pickup address</label>
    </div>
    }
  </div>
</div>

<!-- Same warning as the delivery branch, and the same reason: the backend
     dates and prices an explorer's carts by the day they started with. -->
@if (explorerSelectionChanged()) {
<div class="row form-row animated fadeInDown">
  <div class="col-md-12">
    <div class="alert alert-warning mb-0" role="alert">
      You've changed your pickup day. The items already in your basket are held
      for the original one, so they'll be released if you continue.
    </div>
  </div>
</div>
}

<!-- Pickup delivery day options -->
<div class="row form-row animated fadeInDown">
  <div class="col-md-6">
    <h6 class="signup__sub-head-text">When will you be picking up your order</h6>
    <mat-form-field class="w-100" [class.option-selected]="!!selectedPickUpOption()">
      <mat-label>Choose a day</mat-label>
      <mat-select name="selectedDeliveryDay" [value]="selectedPickUpDeliveryDay()?.id || null"
        (selectionChange)="setSelectedPickUpDeliveryDays($event)">
        @for (item of pickUpDeliveryDays; track $index) {
        <mat-option [value]="item.id">{{ item.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <!-- Delivery day time window: -->
  <div class="col-md-6 d-flex align-items-end">
    @if (selectedPickUpDeliveryDay()) {
    <mat-form-field class="w-100 animated fadeInLeft">
      <mat-label>Time window</mat-label>
      <input type="text" matInput readonly="true" name="selectedDeliveryTimeWindow"
        [value]="selectedPickUpDeliveryDay()?.deliveryWindow">
    </mat-form-field>
    }
  </div>
</div>

@if (selectedPickUpOption()?.additionalInfo) {
<div class="alert alert-warning d-flex align-items-center animated fadeIn mt-4 px-5" role="alert">
  <div class="h7-regular">
    <div class="pickup-additional-info" [innerHTML]="selectedPickUpOption()?.additionalInfo"></div>
  </div>
</div>
}

<div class="row form-row-action">
  <div class="col">
    <div class="d-grid gap-2 mt-4 col-md-2 col-12 w-50 mx-auto">
      <button type="button" (click)="prevContinuePickup()" class="btn btn-secondary animated fadeIn head-font">
        Continue
      </button>
    </div>
  </div>
</div>

} @else {
<!-- Delivery option which required check address validation -->
<form class="needs-validation"
  [class.was-validated]="!!validSelectedAddress() && deliveryAddress().deliveryNotes != '' && (this.deliveryAddress().zipCode?.length ?? 0) === 5">
  <!-- Email for Delivery flow -->
  <div class="row form-row mt-5">
    <div class="col-md-6">
      <div class="form-floating">
        <input type="email" class="form-control" name="signupEmail" placeholder="Email"
          [class.is-invalid]="(signupEmail() !== '' && !isSignupEmailValid()) || emailAlreadyInUse()"
          [class.is-valid]="isSignupEmailValid() && isEmailAvailable()"
          [disabled]="isCheckingEmail()"
          [ngModel]="signupEmail()"
          (ngModelChange)="onEmailChange($event)"
          (blur)="onEmailBlur()" />
        <label for="signupEmail">Email</label>
        @if (signupEmail() !== '' && !isSignupEmailValid()) {
        <div class="invalid-feedback d-block">
          <i class="fas fa-xmark"></i>
          Please enter a valid email address
        </div>
        } @else if (emailAlreadyInUse()) {
        <div class="invalid-feedback d-block">
          <i class="fas fa-xmark"></i>
          This email is already in use. Please use another or sign in.
        </div>
        } @else if (isCheckingEmail()) {
        <div class="form-text small text-muted d-block">
          <i class="fas fa-spinner fa-spin"></i>
          Checking email...
        </div>
        }
      </div>
    </div>
    <div class="col-md-6">
      <app-autocomplete-input (validSelectedAddress)="onValidDeliveryAddressSelected($event)"></app-autocomplete-input>
    </div>
  </div>
  @if (!!validSelectedAddress() || addressWithoutZipCode()) {
  <div class="row form-row animated fadeInDown mt-5">
    @if (!addressWithoutZipCode()) {
    <div class="col">
      <div class="form-floating">
        <input type="text" class="form-control" name="additionalAddress" maxlength="100"
          [class.is-valid]="(deliveryAddress().additionalAddress?.length ?? 0) > 0"
          [ngModel]="deliveryAddress().additionalAddress"
          (ngModelChange)="updateDeliveryAddress({additionalAddress: $event })"
          placeholder="Type your additional address information" />
        <label for="additionalAddressCtrl">Additional address information</label>
      </div>
    </div>
    }
    <div class="col" [class.col-8]="addressWithoutZipCode()">
      <div class="form-floating">
        <input type="text" class="form-control" name="zipCode"
          [class.is-invalid]="(this.deliveryAddress().zipCode?.length ?? 0) < 5"
          [class.is-valid]="(this.deliveryAddress().zipCode?.length ?? 0) === 5" [ngModel]="deliveryAddress().zipCode"
          (ngModelChange)="updateDeliveryAddress({zipCode: $event })" placeholder="Type your ZIP Code" required
          minlength="5" />
        <label for="zipCodeCtrl">ZIP Code</label>
        <div class="invalid-tooltip">
          @if(addressWithoutZipCode()) {
          Please provide your ZIP code and click the "Check Address" button.
          } @else {
          Please provide a valid ZIP Code
          }
        </div>
      </div>
    </div>

    @if (addressWithoutZipCode()) {
    <div class="col-4">
      <button class="btn btn-outline-secondary w-100 h-100" (click)="checkAddressByZipCode()"
        [disabled]="!this.deliveryAddress().zipCode">Check Address</button>
    </div>
    }
  </div>
  }

  @if (validSelectedAddress()) {
  <div class="row form-row animated fadeInDown">
    <div class="col">
      <div class="form-floating">
        <textarea class="form-control"
          placeholder="Please help our drivers find you and get your order to the right place. Consider including details such as: where to leave your box, any building or gate codes, or identifying features for your residence."
          name="deliveryNotes" maxlength="150" [class.is-invalid]="deliveryAddress().deliveryNotes == ''"
          [class.is-valid]="deliveryAddress().deliveryNotes != ''" [ngModel]="deliveryAddress().deliveryNotes"
          (ngModelChange)="updateDeliveryAddress({deliveryNotes: $event})" style="height: 100px">
                    </textarea>
        <label for="deliveryNotesCtrl"
          title="Please help our drivers find you and get your order to the right place. Consider including details such as: where to leave your box, any building or gate codes, or identifying features for your residence.">Please
          help our drivers find you and get your order to the right place. Consider including details such as: where to
          leave your box, any building or gate codes, or identifying features for your residence.</label>
      </div>
    </div>
  </div>

  <!-- The backend dates and prices an explorer's carts by their zone and day.
       Moving either one cancels them, so say so before they find out. -->
  @if (explorerSelectionChanged()) {
  <div class="row form-row animated fadeInDown">
    <div class="col-md-12">
      <div class="alert alert-warning mb-0" role="alert">
        You've changed your delivery zone or day. The items already in your basket
        are held for the original one, so they'll be released if you continue.
      </div>
    </div>
  </div>
  }

  <!-- Check Address Flow: delivery day and time window configuration -->
  @if (checkAddressDeliveryDays && checkAddressDeliveryDays.formattedName) {
  <div class="row form-row animated fadeInDown">
    <!-- Next delivery date -->
    <div class="col-md-12">
      <h6 class="signup__sub-head-text">Your Next Delivery Date Is:</h6>
      <div class="d-flex next-delivery-date">
        <span class="material-symbols-outlined icon fs-3">
          local_shipping
        </span>
        <div class="d-flex flex-column">
          <span class="h5-semibold text-primary">
            {{checkAddressDeliveryDays.formattedName}}
          </span>
          <span class="h6-semibold text-secondary">
            {{checkAddressDeliveryDays.timeSet[0].name}}
          </span>
        </div>
      </div>
    </div>
  </div>
  }

  <div class="row form-row-action ">
    <div class="col">
      <div class="d-grid gap-2 mt-4 col-md-2 col-12 w-50 mx-auto">
        <button type="button" (click)="prevContinue()" class="btn btn-secondary animated fadeIn head-font">
          Continue
        </button>
      </div>
    </div>
  </div>
  }
</form>
}
} @placeholder (minimum 500ms) {
<div class="loading z-n1"></div>
}